import { render, staticRenderFns } from "./vacancy-list.vue?vue&type=template&id=d7bfecda&"
import script from "./vacancy-list.vue?vue&type=script&lang=js&"
export * from "./vacancy-list.vue?vue&type=script&lang=js&"
import style0 from "./vacancy-list.vue?vue&type=style&index=0&id=d7bfecda&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports